import { buildObjectFromEntries } from '~/types/utils'

export const parseHTMLFromString = (stringifiedHTML: string) => {
  const parser = new DOMParser()

  return parser.parseFromString(stringifiedHTML, 'text/html')
}

export const getElementAttributes = (
  htmlElement: Element
): { [key: string]: any } => {
  return buildObjectFromEntries(
    Array.from(htmlElement.attributes).map(attribute => [
      attribute.name,
      attribute.value
    ])
  )
}

export const parseHtmlElementFromString = (
  stringifiedHTML: string
): Element => {
  return parseHTMLFromString(stringifiedHTML).body.firstChild as Element
}
